import { Building2, ChevronRight, Package } from "lucide-react"

/** Header chips of the v2 editor: WHO the declaration is for, then WHAT it
 *  covers. The customer reads as a filled chip with a building icon, the
 *  products as outlined chips with a package icon, so the two are told apart
 *  at a glance even when the customer has no products listed yet. */
export function SubjectChips({
  customerName,
  subjects,
  maxProducts = 4,
}: {
  customerName: string | null | undefined
  subjects: { subjectId: string; number: string; name: string | null }[]
  maxProducts?: number
}) {
  const shown = subjects.slice(0, maxProducts)
  const rest = subjects.length - shown.length
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {customerName && (
        <span className="inline-flex h-6 items-center gap-1.5 rounded-full bg-grey4 px-2.5 text-[11.5px] font-medium text-white">
          <Building2 size={12} className="shrink-0 text-grey5" />
          {customerName}
        </span>
      )}
      {customerName && subjects.length > 0 && (
        <ChevronRight size={12} className="shrink-0 text-grey5" />
      )}
      {shown.map((s) => (
        <span
          key={s.subjectId}
          className="inline-flex h-6 items-center gap-1.5 rounded-full border border-grey4 px-2.5 text-[11.5px] text-grey5"
        >
          <Package size={12} className="shrink-0" />
          <span className="font-mono text-white">{s.number}</span>
          {s.name}
        </span>
      ))}
      {rest > 0 && (
        <span className="inline-flex h-6 items-center rounded-full border border-grey4 px-2.5 text-[11.5px] text-grey5">
          <span className="font-mono text-white">+{rest}</span>
        </span>
      )}
    </div>
  )
}
